import { TFunction } from 'i18next'

import { TransformItemsStructure } from '../../Navigation/elements/NavigationMenu/utils/transformItemsStructure'
import { SearchResultItem } from '../types/searchResultItem'
import { getIconName } from './getIconName'

export const getSearchItemsFromMenu = (
  navigationMenuItems: TransformItemsStructure[],
  parentItem: TransformItemsStructure | undefined,
  t: TFunction,
): SearchResultItem[] => {
  const items: SearchResultItem[] = []
  for (const navigationMenuItem of navigationMenuItems) {
    const { id, title, subItems, to, value } = navigationMenuItem
    const icon = getIconName(navigationMenuItem) || getIconName(parentItem)

    if (subItems?.length) {
      items.push(...getSearchItemsFromMenu(subItems, navigationMenuItem, t))
    } else {
      items.push({
        id,
        icon,
        text: `${t('global_search.go_to')}: ${title}`,
        category: 'menu',
        routeTo: value,
        to,
      })
    }
  }

  return items
}
